import Request from './request';
import { Route, Redirect, Switch } from 'react-router-dom';
import React from 'react';
import PropTypes from 'prop-types';

const SelfRegistration = (props) => {
  const { match } = props;

  return (
    <Switch>
      <Route exact={true} path={`${match.path}/request`} component={Request} />

      <Redirect from={`${match.path}`} to={`${match.path}/request`} />
    </Switch>
  );
};

SelfRegistration.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

export default SelfRegistration;
